import { debounceTime, combineLatest, map } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { Config } from 'app/config.const';
import { Component, Input, EventEmitter, Output } from '@angular/core';

import * as Fuse from 'fuse.js';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'search',
  templateUrl: 'search.component.html',
  styleUrls: [ ]
})
export class SearchComponent<T> {
	// TODO: sanity checks
	
	public term: string;

	private rows = new Subject<T[]>();
	private keys = new Subject<string[]>();

	private subscriptions: Subscription[];

	@Input()
	set items(value: T[]) {
		this.search(null);
		this.rows.next(value);
	}

	@Input()
	set searchKeys(value: string[]) {
		this.keys.next(value);
	}
	
	@Output()
	filtered = new EventEmitter<T[]>();

	public readonly search: (term: string) => void;

	constructor() {

		const terms$ = new Subject<string>();

		this.search = (term:string) => { terms$.next(term) };

		this.subscriptions = [
			terms$.pipe(
				debounceTime(Config.searchDebounceTime),
				combineLatest(
					Observable.combineLatest(this.rows, this.keys).pipe(
						map(([rows, keys]) => 
							Object.assign(new Fuse(
								rows, 
								Object.assign({ keys, minMatchCharLength: 0 }, Config.fuse)
							),
							{ rows }
						))
					)
				))
				.subscribe(([term, fuse]) => {
				  // FIXME: commentato per errore insormontabile
					/*if(term) {
						this.filtered.next(fuse.search(term));
					} else {
						this.filtered.next(fuse.rows);
					}*/
				})
		];
	}

}



// WEBPACK FOOTER //
// ./src/app/components/search/search.component.ts